import router from '@/router'
import { loginRoute } from '@/lib/constants/routes'
import { clearAllAuthentication } from '@/lib/authentication'

const validateResult = (res) => {
  if (router.history.current.name !== loginRoute.name) {
    if (res.statusCode === 401 || res.status === 401) {
      clearAllAuthentication()
      router.push({ name: loginRoute.name })
      return
    }

    if (res.statusCode >= 400 || res.status >= 400) {
      throw Error(res.errorMessage)
    }
  }
}

export default validateResult
